import * as React from 'react'
import { ReactComponent as MultipleDoctorsIcon } from 'src/images/multiple-practitioners.svg'
import useStyles from './AppointmentPractitionerAvatar.styles'
import { getImageUrlWithTransformations } from 'src/utils/getImageUrl'
import { Resize } from '@dentalux/ui-library-core'

type AppointmentPractitionerAvatarProps = {
  imageUrl?: string | null
  hasRecommendedPractitioner: boolean
}

const AppointmentPractitionerAvatar = ({
  imageUrl,
  hasRecommendedPractitioner,
}: AppointmentPractitionerAvatarProps) => {
  const classes = useStyles()

  return (
    <div>
      <div
        className={classes.practitionerAvatar}
        style={
          hasRecommendedPractitioner && imageUrl
            ? {
                backgroundImage: `url(${getImageUrlWithTransformations({
                  src: imageUrl,
                  quality: 'lightest',
                  transformations: [new Resize(200, 200)],
                })})`,
              }
            : {}
        }
      >
        {!hasRecommendedPractitioner && <MultipleDoctorsIcon />}
      </div>
    </div>
  )
}

export default AppointmentPractitionerAvatar
